import { getDatabase, onValue, query, ref } from "firebase/database";
import { useEffect, useState } from "react";
export default function useCurrentUser(phone) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [user, setUser] = useState({});
  useEffect(() => {
    async function fetchUsers() {
      //databse related works
      const db = getDatabase();
      const userRef = ref(db, `Users/${phone}`);
      const userQuery = query(userRef);
      try {
        setError(false);
        setLoading(true);
        //request firebase database;
        onValue(userQuery, (snapshot) => {
          setLoading(false);
          if (snapshot.exists()) {
            setUser((prevCashout) => {
              return snapshot.val();
            });
          }
        });
      } catch (err) {
        setLoading(false);
        setError(true);
      }
    }
    fetchUsers();
  }, [phone]);

  return { loading, error, user };
}
